
const API_URLS = {
    candidate: `${process.env.REACT_APP_SERVER_URL}/api/candidate`,
  };
  
  export default API_URLS;